import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { BottomNav } from './BottomNav';

export function MainLayout() {
  return (
    <div className="relative flex min-h-screen flex-col">
      {/* Atmosphere background */}
      <div
        className="pointer-events-none fixed inset-0 -z-10"
        style={{
          background: 'radial-gradient(ellipse at 50% 0%, hsl(214 100% 45% / 0.03) 0%, transparent 60%), radial-gradient(ellipse at 100% 100%, hsl(16 45% 50% / 0.02) 0%, transparent 50%), hsl(0 0% 98%)',
        }}
      />
      <Header />
      <main className="flex-1 pb-20">
        <Outlet />
      </main>
      <BottomNav />
    </div>
  );
}
